var _path, _circle, _g, _path2, _path3, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCuba(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.001 44.522h-.001v422.956h.001v-211.477z",
    fill: "#ff9811"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255.999,
    cy: 256,
    fill: "#f0f0f0",
    r: 255.999
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0052b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256.001.002c-83.752 0-158.106 40.223-204.811 102.4h409.621c-46.704-62.178-121.059-102.4-204.81-102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.001 511.999c83.752 0 158.106-40.223 204.811-102.4h-409.622c46.704 62.178 121.059 102.4 204.811 102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.001 256.001c0 17.535 1.768 34.657 5.127 51.2h501.747c3.359-16.543 5.126-33.665 5.126-51.2s-1.768-34.657-5.126-51.2h-501.747c-3.359 16.543-5.127 33.665-5.127 51.2z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m74.981 74.982c-99.973 99.973-99.973 262.064 0 362.039 41.313-41.313 81.045-81.046 181.019-181.019z",
    fill: "#d80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m103.611 189.219 16.574 51.015h53.646l-43.397 31.532 16.574 51.016-43.397-31.53-43.399 31.53 16.578-51.016-43.398-31.532h53.642z",
    fill: "#f0f0f0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuba);
export default __webpack_public_path__ + "static/media/cuba.4b31ae1bcb3fc131649176e4c45286ce.svg";
export { ForwardRef as ReactComponent };